import React from 'react';
import Typography from '@mui/material/Typography';
import CustomDialog from '../CustomDialog';
import { useHistory } from 'react-router-dom';

const TermsAndConditions = () => {
    const history = useHistory();
    return (
        <CustomDialog
            title={'Terms And Conditions'}
            onClose={() => {
                history.goBack();
            }}
        >
            <>
                <Typography variant="h3">TERMS AND CONDITIONS</Typography>
                <Typography variant="body1">
          Welcome to KwadHub! By accessing this website, you agree to be bound by these terms and conditions, which
          govern your use of the site and all of its features, content, and services. If you do not agree with any of
          these terms, please do not use this site.
                </Typography>
                <Typography variant="body1">
                    <strong>1. Use of the Site:</strong> KwadHub is a platform that allows users to track their spots where they
          can fly quadcopters and other UAVs. Users can share these spots with others. By using this site, you agree to
          use it only for lawful purposes and in compliance with all applicable laws and regulations.
                </Typography>
                <Typography variant="body1">
                    <strong>2. User Content:</strong> KwadHub allows users to upload content, including photos, videos, and other
          materials. By uploading content, you agree to grant KwadHub a non-exclusive, worldwide, perpetual,
          irrevocable, royalty-free, sublicensable license to use, modify, distribute, and display the content in
          connection with the site and its services.
                </Typography>
                <Typography variant="body1">
                    <strong>3. Liability:</strong> KwadHub does not endorse or guarantee the accuracy, completeness, or usefulness
          of any content on the site, nor does it endorse any user's use of the site. KwadHub is not responsible for any
          loss or damage of any kind arising from or in connection with the use or reliance on any content posted on the
          site, whether by users or by KwadHub. KwadHub is not responsible for any injury, loss, or damage incurred as a
          result of the use of the site or its services.
                </Typography>
                <Typography variant="body1">
                    <strong>4. Intellectual Property:</strong> All content and materials on the site, including but not limited to
          logos, trademarks, and copyrighted works, are the property of KwadHub or its licensors. You may not use any
          content or materials on the site without the express written consent of KwadHub.
                </Typography>
                <Typography variant="body1">
                    <strong>5. Indemnification:</strong> You agree to indemnify, defend, and hold KwadHub harmless from any claim,
          demand, or damage, including reasonable attorneys' fees, arising out of or in connection with your use of the
          site or its services, your violation of these terms and conditions, or your violation of any rights of
          another.
                </Typography>
                <Typography variant="body1">
                    <strong>6. Termination:</strong> KwadHub reserves the right to terminate or suspend your use of the site at
          any time, for any reason, without notice or liability.
                </Typography>
                <Typography variant="body1">
                    <strong>7. Governing Law:</strong> These terms and conditions shall be governed by and construed in accordance
          with the laws of the state of [insert state], without giving effect to any principles of conflicts of law.
                </Typography>
                <Typography variant="body1">
                    <strong>8. Modification:</strong> KwadHub may modify these terms and conditions at any time, in its sole
          discretion. Your continued use of the site after any such modifications will constitute your acceptance of
          such modifications.
                </Typography>
                <Typography variant="body1">
          By using this site, you acknowledge that you have read, understood, and agree to be bound by these terms and
          conditions. If you have any questions or concerns, please contact us at [insert contact information].
                </Typography>
            </>
        </CustomDialog>
    );
};

export default TermsAndConditions;
